import { Crud } from 'core/types/Crud'

export interface IBusinessOwner {
  Email: string
  FirstName: string
  LastName: string
  JobTitle: string
  Ownership: number
}

export interface ICrudObject {
  label: string
  key: string
}

export interface IPartnerShipNaCrud {
  OwnershipStructure: Crud<ICrudObject>
  Duration: Crud<ICrudObject>
  PrimaryBusinessModel: Crud<ICrudObject>
  AgentPartner: Crud<ICrudObject>
  PartnerRecruited: Crud<ICrudObject>
  OnlineByUser: Crud<ICrudObject>
  IsResidentailAddress: Crud<ICrudObject>
  SoleProprietor: Crud<ICrudObject>
  IsDistributor: Crud<ICrudObject>
}

export interface IPartnerShipNaCrudExtended extends IPartnerShipNaCrud {
  Distributors: Crud<ICrudObject>
}

export enum QualifiedProgramApproval {
  none = '',
  approve = 'Approve',
  reject = 'Reject',
}

export interface IPartnerShipNA {
  EntryId: number
  PartnershipType: string
  RequestId: number

  AcceptanceDate: string
  AgentPartner: string
  Comments: string
  Companies: number
  DirectSalesForce: number
  OwnURL: number
  Marketplace: number
  Distributor: string
  Duration: string
  ExceptionGranted: string
  OwnershipStructure: string
  Individuals: number
  OnlineByEmailID: string
  OnlineByName: string
  OnlineByUser: string
  PartnerRecruited: string
  PrimaryBusinessModel: string
  TotalSellingMethods: number
  TotalSellingMotion: number
  BusinessOwner: string
  IsResidentailAddress: string
  SignatoryFirstName: string
  SignatoryLastName: string
  SignatoryEmail: string
  JobFunction: string
  IsInactiveUser: string
  AgreeSellToEndUsers: string | null
  AgreeSellProductsInTerritory: string | null
  AreYouDistri: string | null
  OwnershipStructureOther: string | null
  QualifiedBPS: string | null
  ApprovalBPS: QualifiedProgramApproval
  QualifiedCPS: string | null
  ApprovalCPS: QualifiedProgramApproval
  QualifiedPrintHW: string | null
  ApprovalPrint: QualifiedProgramApproval
  QualifiedPoly: string | null
  ApprovalPoly: QualifiedProgramApproval
  QualifiedSupplies: string | null
  ApprovalSupplies: QualifiedProgramApproval
  QualifiedSoftware: string | null
  ApprovalSoftware: QualifiedProgramApproval
  AgreeSellThroughOwnURL: string | null
}
